<template>
  <v-card outlined>
    <v-card-title>{{ $t("receipt_summary") }}</v-card-title>
    <v-divider />
    <v-card-text class="px-6 py-5">
      <div class="d-flex justify-space-between align-center body-2 mb-4">
        <span class="grey--text text--darken-1">{{ $t("warehouse.items_count") }}:</span>
        <strong>{{ itemsCount }}</strong>
      </div>
      <div class="d-flex justify-space-between align-center body-2 mb-4">
        <span class="grey--text text--darken-1"
          >{{ $t("warehouse.total_quantity") }}:</span
        >
        <strong>{{ formattedQuantity }}</strong>
      </div>
      <div class="d-flex justify-space-between align-center body-2">
        <span class="grey--text text--darken-1">{{ $t("warehouse.total_amount") }}:</span>
        <strong>{{ formattedValue }}</strong>
      </div>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-btn
        color="primary"
        depressed
        block
        large
        class="text-none"
        :disabled="saveDisabled"
        :loading="loading"
        @click="$emit('finish')"
      >
        <v-icon left>mdi-check-circle-outline</v-icon>
        {{ $t("finish_entry") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import hasReceiptCalculations from "@/mixins/warehouse/hasReceiptCalculations";

export default {
  name: "WarehouseReceiptSummaryCard",
  mixins: [hasReceiptCalculations],
  props: {
    editedItem: { type: Object, required: true },
    groceries: { type: Array, default: () => [] },
    documentTransactions: { type: Array, default: () => [] },
    valid: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  computed: {
    totalEnteredQuantity() {
      return this.groceries.reduce(
        (sum, g) => sum + this.getGroceryDelivered(g) + this.getCurrentReceiptAmount(g),
        0
      );
    },
    totalReceiptValue() {
      return this.groceries.reduce((sum, g) => sum + this.getCurrentLineValue(g), 0);
    },
    itemsCount() {
      return (
        this.groceries.filter(
          (g) => this.getCurrentReceiptAmount(g) > 0 || this.isFullyDelivered(g)
        ).length || this.groceries.length
      );
    },
    measureLabel() {
      const unique = [...new Set(this.groceries.map((g) => g.measure).filter(Boolean))];
      return unique.length === 1 ? unique[0] : "";
    },
    formattedQuantity() {
      return this.measureLabel
        ? `${this.totalEnteredQuantity} ${this.measureLabel}`
        : this.totalEnteredQuantity;
    },
    formattedValue() {
      return `${(this.totalReceiptValue || 0).toFixed(2)} ${this.restaurantCurrency}`;
    },
    receivedById() {
      const user = this.editedItem.received_by;
      if (!user) return null;
      return typeof user === "object" ? user.id : user;
    },
    hasEnteredQuantities() {
      return this.groceries.some((g) => this.getCurrentReceiptAmount(g) > 0);
    },
    saveDisabled() {
      return (
        !this.valid ||
        !this.receivedById ||
        !this.editedItem.warehouse_id ||
        !this.hasEnteredQuantities ||
        this.loading
      );
    },
  },
};
</script>
